export default "__VITE_ASSET__d3gUBugi__"